import { render, staticRenderFns } from "./sales-orders.vue?vue&type=template&id=15aaaa83&scoped=true&"
import script from "./sales-orders.vue?vue&type=script&lang=js&"
export * from "./sales-orders.vue?vue&type=script&lang=js&"
import style0 from "./sales-orders.vue?vue&type=style&index=0&id=15aaaa83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aaaa83",
  null
  
)

export default component.exports